import React, { Component } from 'react';

/**
 * General component description.
 */
class Footer extends Component {
	render() {
	return(
		<p>Edu Vibe | Copyright &copy; 2022
			<br/>
			Made with &#x2764;&#xfe0f; in <b>India</b>
		<p> Contact to build sites for your business</p>
		<p> this looks interesting </p>
		</p>
	);
	}
}

export default Footer;

	
